module.exports = __webpack_public_path__ + "static/media/bg-photo@2x.138c9d69.png";